import _ from 'lodash';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {fetchCurrentStep} from 'CourseAction';

class Navigation extends Component {
    constructor(props) {
        super(props);
        this.state = {loading: false};
    }

    componentDidMount() {
       
    }

    redirectUrl = (e) => {
        e.preventDefault();
        let {courseWizardStep,allUnpublishedCourseList} = this.props;
        let current_step = courseWizardStep; // Check current active tab
        let current_stepArr = current_step.split('_');

        let clicked_step = e.currentTarget.dataset.data_id; // Check Clicked tab
        let clicked_stepArr = clicked_step.split('_');
        
        let nextStep = false;
        if(clicked_step == 'step_2' && allUnpublishedCourseList && allUnpublishedCourseList.resource && allUnpublishedCourseList.resource.length > 0) {
            nextStep = true;
        }
        else if(clicked_step == 'step_3' && allUnpublishedCourseList && allUnpublishedCourseList.resource && allUnpublishedCourseList.resource.length > 0 && allUnpublishedCourseList.resource[0].course_chapter_by_courseid && allUnpublishedCourseList.resource[0].course_chapter_by_courseid.length > 0) {
            nextStep = true;
        }
        else if(clicked_step == 'step_4' && allUnpublishedCourseList && allUnpublishedCourseList.resource && allUnpublishedCourseList.resource.length > 0 && allUnpublishedCourseList.resource[0].ticketid) {
            nextStep = true;
        }
        
        if(clicked_stepArr[1] < current_stepArr[1]) {
            this.props.fetchCurrentStep(clicked_step);
        }
        else if((clicked_stepArr[1] > current_stepArr[1]) && nextStep) {
            this.props.fetchCurrentStep(clicked_step);
        }
    }

    renderTabs = () => {
        let {courseWizardStep,courseWizardAllSteps,allUnpublishedCourseList} = this.props;

        return _.map(courseWizardAllSteps, (step, index) => {
            let currentStep = step.tab;
            let icon='fa fa-exclamation-circle';
            let style='steps-not-filled';
            let isActive = courseWizardStep == currentStep ? 'activestepColor' : 'stepColor';

            if(currentStep == 'step_1' && allUnpublishedCourseList && allUnpublishedCourseList.resource && allUnpublishedCourseList.resource.length > 0) {
                icon='fa fa-check-circle';
                style='steps-filled';
            }
            else if(currentStep == 'step_2' && allUnpublishedCourseList && allUnpublishedCourseList.resource && allUnpublishedCourseList.resource.length > 0 && allUnpublishedCourseList.resource[0].course_chapter_by_courseid && allUnpublishedCourseList.resource[0].course_chapter_by_courseid.length > 0) {
                icon='fa fa-check-circle';
                style='steps-filled';
            }
            else if(currentStep == 'step_3' && allUnpublishedCourseList && allUnpublishedCourseList.resource && allUnpublishedCourseList.resource.length > 0 && allUnpublishedCourseList.resource[0].ticketid) {
                icon='fa fa-check-circle';
                style='steps-filled';
            }
            else if(currentStep == 'step_4' && allUnpublishedCourseList && allUnpublishedCourseList.resource && allUnpublishedCourseList.resource.length > 0 && allUnpublishedCourseList.resource[0].ispublished) {
                icon='fa fa-check-circle';
                style='steps-filled';
            }
            else {
                icon='fa fa-exclamation-circle';
                style='steps-not-filled';
            }

            return(
                <li key={`tab_${index}`}>
                    <a href="#" data-data_id={currentStep} onClick={this.redirectUrl}>
                        <div style={{display:'flex'}}>
                            <div><i className={`${icon} ${style}`} aria-hidden="true"></i> </div>
                            <div className={isActive}>{step.tabname}</div>
                        </div>
                    </a>
                </li>
            );
        });

    }

    render() {
        
        return (
            <div>
                <ul className="wizard_breadcrumb breadcrumb-ipad">

                    {this.renderTabs()}

                </ul>
            </div>   
        );
    }
}

function mapStateToProps(state) {


    return {
        session: state.session,
        courseWizardStep: state.courseWizardStep,
        courseWizardAllSteps: state.courseWizardAllSteps,
        allUnpublishedCourseList: state.allUnpublishedCourseList,
    };
}
export default connect(mapStateToProps,{fetchCurrentStep})(Navigation);